/** @const {string} */
export const GAMELAB_DPAD_CONTAINER_ID = 'studio-dpad-container';
